import { Feature } from './rolesAndFeatures'

/**
 * The two monetisation products a scope can be sold, named as customers know them.
 *
 * Deliberately not the `adm`/`pbs` code namespaces: those are API paths and tracking prefixes, and a
 * customer-facing pitch that says "adm" is a pitch nobody wrote on purpose.
 */
export const UPGRADE_OFFERS = ['one', 'node'] as const
export type UpgradeOffer = (typeof UPGRADE_OFFERS)[number]

/** The entitlement that makes an offer owned. Neither feature is named after its product. */
export const UPGRADE_OFFER_FEATURE: Record<UpgradeOffer, Feature> = {
  one: 'adstack',
  node: 'pbsStandalone',
}

export const UPGRADE_OFFER_LABEL: Record<UpgradeOffer, string> = {
  one: 'One',
  node: 'Node',
}
